// extracted by mini-css-extract-plugin
export default {"headerAssessment":"AssessmentHeader_headerAssessment__0VEWN"};